(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('CreditsAddonController', CreditsAddonController);

        CreditsAddonController.$inject = ['$scope', '$state', 'History'];

    function CreditsAddonController($scope, $state, History) {
        var vm = this;
        vm.credits;
        init();
        function init(){
            loadCreditsHistory();
            
            // listen for the event in the relevant $scope
            $scope.$on('quilinkApp:connexionUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:profileUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:positionUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:companyUpdate', function (event, data) {
                loadCreditsHistory();
            });

            $scope.$on('quilinkApp:collectivityUpdate', function (event, data) {
                loadCreditsHistory();
            });
        }
        
        function loadCreditsHistory() {
            History.myCredits({}, function (response) {
                vm.credits = response;
            });
        }
    }
})();
